import type { VariantProps } from "class-variance-authority";
import React, { forwardRef } from "react";

import { buttonVariants } from "@/components/button/button-variants";

interface LinkProps
  extends Omit<VariantProps<typeof buttonVariants>, "isInline">,
    React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children?: React.ReactNode;
  className?: string;
  href: string;
}

const Link = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => {
  const { className, pattern, size, variant, children, href, ...rest } = props;

  const classes = buttonVariants({
    pattern,
    size,
    variant,
    isInline: true,
    className,
  });

  return (
    <a ref={ref} className={classes} href={href} {...rest}>
      {children}
    </a>
  );
});

Link.displayName = "Link";

export { Link };
export type { LinkProps };
